import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createLazyRoute } from "@/app/routing/LazyRoute";
import { ProtectedRoute } from "@/app/routes/ProtectedRoute";
import { WorkspaceNavigationAdapter } from "@/app/routes/WorkspaceNavigationAdapter";

// Eager: `/` is the entry URL for every visitor who has not been here before,
// and a chunk fetch on top of the document would only add a round trip to the
// one paint that cannot afford it. Every other route is loaded on demand.
import LandingRoute from "@/app/routes/public/LandingRoute";

const LoginRoute = createLazyRoute(() => import("@/app/routes/auth/LoginRoute"));
const OnboardingRoute = createLazyRoute(() => import("@/app/routes/onboarding/OnboardingRoute"));
const DashboardRoute = createLazyRoute(() => import("@/app/routes/dashboard/DashboardRoute"));
const WorkspaceRoute = createLazyRoute(() => import("@/app/routes/workspace/WorkspaceRoute"));
const PendingInvitationsRoute = createLazyRoute(() => import("@/app/routes/invitations/PendingInvitationsRoute"));
const InvitationAcceptRoute = createLazyRoute(() => import("@/app/routes/invitations/InvitationAcceptRoute"));
const AccountSettingsRoute = createLazyRoute(() => import("@/app/routes/account/AccountSettingsRoute"));
const ConnectedAppConsentRoute = createLazyRoute(() => import("@/app/routes/integrations/ConnectedAppConsentRoute"));
const UnsubscribeRoute =createLazyRoute(() => import("@/app/routes/notifications/UnsubscribeRoute"));
const MeetingPrepRoute = createLazyRoute(() => import("@/app/routes/meetings/MeetingPrepRoute"));
const PrivacyRoute = createLazyRoute(() => import("@/app/routes/public/PrivacyRoute"));
const NotFoundRoute = createLazyRoute(() => import("@/app/routes/public/NotFoundRoute"));

export function AppRoutes() {
  return (
    <BrowserRouter>
      <WorkspaceNavigationAdapter>
        <Routes>
          <Route path="/" element={<LandingRoute />} />
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/invitations/accept" element={<InvitationAcceptRoute />} />
          {/* ProtectedRoute stays eager, so the redirect for a signed-out
              visitor is decided before any chunk is fetched. */}
          <Route path="/onboarding" element={<ProtectedRoute><OnboardingRoute /></ProtectedRoute>} />
          <Route path="/invitations" element={<ProtectedRoute><PendingInvitationsRoute /></ProtectedRoute>} />
          <Route path="/account-settings" element={<ProtectedRoute><AccountSettingsRoute /></ProtectedRoute>} />
          <Route path="/oauth/consent" element={<ProtectedRoute><ConnectedAppConsentRoute /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardRoute /></ProtectedRoute>} />
          {/* The section is a path segment; the team is `?team=`. Both routes
              render the same route — `/w/:slug` is home. See TEAMS.md § 5.4 for
              why the team is not a segment here. */}
          <Route path="/w/:workspaceSlug" element={<ProtectedRoute><WorkspaceRoute /></ProtectedRoute>} />
          <Route path="/w/:workspaceSlug/:section" element={<ProtectedRoute><WorkspaceRoute /></ProtectedRoute>} />
          <Route path="/unsubscribe" element={<UnsubscribeRoute />} />
          <Route path="/prep/:token" element={<MeetingPrepRoute />} />
          <Route path="/privacy" element={<PrivacyRoute />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFoundRoute />} />
        </Routes>
      </WorkspaceNavigationAdapter>
    </BrowserRouter>
  );
}
